import angular from 'angular';
import brokenImgUrl from '../../images/outline-broken_image-24px.svg';
import ComponentsModule from '../components-module';
import ContentCard from './code-content-card';
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'ContentCardService';
const debug = new Debug (COMPONENT_NAME);

angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, ($q, $sanitize, ContentService, ContentStateService, ImageService) => {

    const fromAceUISearch = (content) => {

      let args = content;

      if (!Array.isArray (content)) {
        args = [content];
      }

      let result = args.map ((content) => {
        let data = {};

        let aceUISearchEntry = content.aspects.aceUISearchEntry;

        if (aceUISearchEntry.contentCard) {
          data = JSON.parse (JSON.stringify (aceUISearchEntry.contentCard, (key, value) => {
            if (!key.endsWith ('_type')) {
              return value;
            }
          }));
          data.label = data.label || content.system.id;
        } else {
          data = {
            label: aceUISearchEntry.title || content.system.id,
            configurations: [{
              contexts: ['CONTENT-ACTIVITY', 'CONTENT-WORKFLOW', 'RECENT-CONTENT', 'SEARCH-VIEW', 'SEARCH-DROPDOWN', 'CONTENT-SELECT', 'CONTENT-SELECT-SEARCH'],
              fields: {
                thumbnail: {
                  alias: aceUISearchEntry.thumbnailImageId,
                  url: aceUISearchEntry.thumbnailImageUrl
                }
              }
            }, {
              contexts: ['CONTENT-ACTIVITY', 'CONTENT-WORKFLOW'],
              fields: {
                label: {
                  rows: 1
                },
                abstract: {
                  value: aceUISearchEntry.text,
                  rows: 1
                },
                datetime: {
                  ISOstring: content.system.modificationTime
                }
              }
            }, {
              contexts: ['CONTENT-ACTIVITY'],
              fields: {
                tags: [content.system.contentType]
              }
            }, {
              contexts: ['SEARCH-DROPDOWN'],
              fields: {
                label: { rows: 1 },
                contentType: content.system.contentType
              },
            }]
          };
        }
        data.alias = content.system.id;

        if (!data.contentType) {
          data.contentType = {};
        }
        if (typeof data.contentType === 'string') {
          data.contentType = { label: data.contentType };
        }
        data.contentType.value = content.system.contentType;

        debug.log ('data', data);
        let contentCard = new ContentCard (data);
        debug.log ('contentCard', contentCard);

        return contentCard.sanitize ($sanitize);
      });

      if (!Array.isArray(content)) {
        return result[0];
      } else {
        return result;
      }
    };

    const resolveThumbnail = async (thumbnail) => {
      if (!thumbnail || thumbnail.url || !thumbnail.alias) {
        return thumbnail;
      }

      let imageServiceOptions = {
        aspectRatio: thumbnail.aspectRatio || '1:1'
      };

      if (!thumbnail.width) {
        imageServiceOptions.width = 210;
      } else if (thumbnail.width < 110) {
        imageServiceOptions.width = 105;
      } else {
        imageServiceOptions.width = 210;
      }

      try {
        let isHidden = await ContentStateService.getHiddenState (thumbnail.alias);
        if (!isHidden) {
          try {
            let response = await ContentService.getContent ({
              alias: thumbnail.alias,
              variant: 'aceUISearch',
              view: 'aceLatest'
            });

            thumbnail.alt =
              atex.aceui.ObjectUtils.getByPath (response, 'content/aspects/aceUISearchEntry/contentCard/abstract')
              || atex.aceui.ObjectUtils.getByPath (response, 'content/aspects/aceUISearchEntry/text')
              || '';

            imageServiceOptions.version = response.content.system.version;
          } catch (error) {
            console.warn ('Error while loading thumbnail data.', error);

            imageServiceOptions.alias = thumbnail.alias;
            imageServiceOptions.view = 'aceLatest';
          }

          thumbnail.url = await ImageService.getImageUrl(imageServiceOptions);

          return thumbnail;
        }
      } catch (error) {
        console.error ('ERROR: loading thumbnail', error);
        thumbnail.url = brokenImgUrl;
        thumbnail.alt = 'No image';
        return thumbnail;
      }
    };

    return {
      fromAceUISearch,
      resolveThumbnail: (thumbnail) => $q.resolve (resolveThumbnail (thumbnail))
    };
  });
